import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';
import { RowAlignCenter } from '../layout';

export const AwardLogo = styled.img`
  max-width: 250px;
  max-height: 80px;
  margin-bottom: 15px;
`;

export const AgentText = styled.p`
  color: ${(props) => props.theme.textMid};
  font-size: 14px;
  text-align: center;
`;

export const AgentBoxFixed = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${(props) => props.theme.background};
  width: 100%;
  height: 60px;
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  gap: 10px;
  border-bottom: 1px solid ${(props) => props.theme.keyline};
  transition: 300ms all;

  img {
    max-width: 200px;
    max-height: 40px;
  }

  ${AgentText} {
    text-align: left;
  }

  @media (${tabletMax}) {
    ${RowAlignCenter} {
      display: none;
    }
  }
`;

export const NameAndPSRTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AgentBoxFixedButtons = styled.div<{ numBtns: number }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: ${({ numBtns }) => numBtns * 240}px;
  gap: 5px;

  @media (max-width: ${({ numBtns }) => 240 + numBtns * 240}px) {
    max-width: ${({ numBtns }) => 240 + numBtns * 240}px;
    p {
      font-size: 13px;
    }
  }
`;

export const LicenceWarning = styled(Link)`
  width: 20px;
  height: 20px;
  background-color: ${(props) => props.theme.primary};
  border-radius: 10px;
  display: inline-block;
  font-weight: bold;
  color: ${(props) => props.theme.white};
  margin-left: 5px;
`;
